module.exports = __webpack_public_path__ + "img/lifepak_AED1000.c9575769.png";